<div class="custombg fixed-top">
  <app-header></app-header>
  <app-breadcrumb></app-breadcrumb>

</div>

<div class="main" *ngIf="orgHideit">

  <div class="title">
    <div class="sub-title">


      <div class="skillmatturity">
        <!-- <img src="../../../../assets/images/cloud/cmf.png" width="100%" height="100%"> -->
        <div class="grid-container">
          <div class="card cardstyle">
            <span class="material-symbols-outlined spanstyle" style="color: green; "> group </span>

            <div style="display: flex; flex-direction: column;">
              <p class="parastyle">{{resourceCount}}</p>
              <p class="subparastyle">Resources</p>
            </div>
          </div>
          <div class="card cardstyle"><span class="material-symbols-outlined spanstyle" style="color:rgb(202, 98, 98);">
              passkey </span>
            <div style="display: flex; flex-direction: column;">
              <p class="parastyle">{{smeCount}}</p>
              <p class="subparastyle">SME'S</p>
            </div>
          </div>
          <div class="card cardstyle"><span class="material-symbols-outlined spanstyle"
              style="color:blue;">workspace_premium</span>
            <div style="display: flex; flex-direction: column;">
              <p class="parastyle">{{certificationCount}}</p>
              <p class="subparastyle">Certifications</p>
            </div>
          </div>
          <div
            style="grid-row: span 3;width: 35rem; background-color: #fff; border-radius: 5px; border: 1px solid #ccc;">
            <div class="paternship_block">
              <div class="heading">Partnerships</div>
              <div class="partnership_icon">
                <span class="material-symbols-outlined " (click)="navigateToPartnershipGrid()">settings</span>
              </div>
            </div>
            <div class="image-container border-right">
              <div class="data_soruce_image" *ngFor="let item of dataSource.slice(0, 4); let i = index">
                <img [src]="'data:image/jpg;base64,' + item.logo" height="80" width="80">
                <span class="partnershipName">{{item.name}}</span>
              </div>
            </div>
          </div>
          <p class="" style="margin-left:4px;font-weight: bold;line-height: normal;">Solutions by Vertical</p>
          <div class="card" style="grid-column: span 3;width:955px;height:81px;margin-top: -15px;">
            <div style="display: flex; justify-content: space-between;">
              <div style="display: flex; flex-direction: row; align-items: center;">
                <span class="material-symbols-outlined solutionByVerticalIcons">account_balance</span>
                <div style="margin-left: 10px;">
                  <p class="parastyle">{{solutionByVertical?.bfsCount??0}}</p>
                  <p class="subparastyle">BFS</p>
                </div>
              </div>

              <div style="display: flex; flex-direction: row; align-items: center; ">
                <span class="material-symbols-outlined solutionByVerticalIcons">folder_managed</span>
                <div style="margin-left: 10px;">
                  <p class="parastyle">{{solutionByVertical?.candMCount??0}}</p>
                  <p class="subparastyle">C&M</p>
                </div>
              </div>

              <div style="display: flex; flex-direction: row; align-items: center; ">
                <span class="material-symbols-outlined solutionByVerticalIcons">biotech</span>
                <div style="margin-left: 10px;">
                  <p class="parastyle">{{solutionByVertical?.hiTechCount??0}}</p>
                  <p class="subparastyle">Hi-Tech</p>
                </div>
              </div>
              <div style="display: flex; flex-direction: row; align-items: center;">
                <span class="material-symbols-outlined solutionByVerticalIcons">folder_managed</span>
                <div style="margin-left: 10px;">
                  <p class="parastyle">{{solutionByVertical?.hilCount??0}}</p>
                  <p class="subparastyle">Hil</p>
                </div>
              </div>

              <div style="display: flex; flex-direction: row; align-items: center; ">
                <span class="material-symbols-outlined solutionByVerticalIcons">account_balance</span>
                <div style="margin-left: 10px;">
                  <p class="parastyle">{{solutionByVertical?.miscCount??0}}</p>
                  <p class="subparastyle">Misc</p>
                </div>
              </div>

              <div style="display: flex; flex-direction: row; align-items: center; ">
                <span class="material-symbols-outlined solutionByVerticalIcons">add_shopping_cart</span>
                <div style="margin-left: 10px;">
                  <p class="parastyle">{{solutionByVertical?.remttCount??0}}</p>
                  <p class="subparastyle">REMTT</p>
                </div>
              </div>

            </div>
          </div>
        </div>
        <div class="Service_heading custom_subtiles2">Service Lines</div>
        <div class="row mx-0 mb-2">
          <div class="col-2 p-0">
            <div class="subcompentency-sidebar h-100">
              <app-servicelines-sidebar (serviceLine)="updateServiceLine($event)">  </app-servicelines-sidebar>
            </div>
          </div>
          <div class="card col-10">
            <div class="row m-0">
              <div class="col-4 px-2 py-0">
                <div class="row m-0">
                  <div class="col-12 p-0 pr-1">
                    <div class="row m-0 pb-2">
                      <app-resources [resourceWidgetData]="resourceWidgetData"></app-resources>
                    </div>
                    <div class="row m-0 pb-2">
                      <app-certifications class="w-100"></app-certifications>
                    </div>
                    <div class="row m-0 pb-2">
                      <app-trainings [CMFDashBoardData]="CMFDashBoardData" class="w-100"></app-trainings>
                    </div>

                  </div>
                </div>

              </div>
              <div class="r">

              </div>
              <div class="col-4 py-0" >
                <div class="row m-0" style="width: 100.5%;">
                  <div class="col-12 p-0 pr-1">
                    <div class="row m-0 pb-2">
                      <app-audits></app-audits>
                    </div>
                    <div class="row m-0 pb-2">
                      <app-others class="w-70"></app-others>
                      <div class="countProposalGrps">
                      <mat-card class="matInterviews">
                        <div class="table-container tblWidth">
                          <table>
                            <tr>
                              <td class="iconInterviews">
                                <span class="material-symbols-outlined alignpos" >
                                  work
                                  </span>
                            </td>
  
                              <td width="80%" class="countvalue"> 
                                {{interviewCount}}<br>  
                                <div class="textsize" >Interviews</div>                            
                              </td> 
                              <td width="5%" class="refreshCount" title="Refresh Interviews" (click)="getInterviewCount()"> 
                                <span class="material-symbols-outlined" >Refresh</span> 
                              </td> 
                              
                            
                            </tr>   
                            
                          </table>
                        </div>
                      </mat-card>
                      <mat-card class="matProposals">
                        <div class="table-container tblWidth">
                          <table>
                            <tr>
                              <td class="iconProposal">
                                <span class="material-symbols-outlined alignpos" >
                                  eye_tracking
                                </span>
                              </td>
                              <td width="80%" class="countvalue"> 
                                {{ mentorsCount }}<br>  
                                <div
                                  class="textsize"
                                  (click)="navigateToMentorsList()"
                                >Mentors</div>                            
                              </td> 
                              <td
                                width="5%"
                                class="refreshCount"
                                title="Refresh Mentors"
                                (click)="getMentorsCount()"
                              > 
                                <span class="material-symbols-outlined">Refresh</span>
                              </td> 
                            </tr>   
                          </table>
                        </div>
                      </mat-card>
                    </div>
                    </div>
                    <div class="row m-0 pb-2">
                    
                    </div>
                  </div>
                </div>

              </div>
              <div class="col-4 px-2 py-0">
                <div class="main_org_container">
                  <div class="Org_Heading">
                    <div> Maturity Levels</div>
                    <span class="material-symbols-outlined CMP_icon" (click)="maturity_portal()">
                      settings
                    </span>

                  </div>
                  <div class="org_map_container">
                    <div class="org_map_list">
                      <div class="Hierarchy_map capacity_container">
                        <div class="name_class"><span>
                            Capacity
                          </span></div>
                      </div>
                      <div class="sub_hierarchy_map_container">

                        <div class="sub_hierarchy_map_list">
                          <div class="sub_hierarchy_map_name">Deployable Content</div>
                          <div class="logo_percentage">
                            <img src="../../../../assets/images/cloud/50.png" width="100%" height="100%"
                              alt="90perctenage">
                          </div>
                        </div>
                        <div class="sub_hierarchy_map_list">
                          <div class="sub_hierarchy_map_name">Aglity to Scale</div>
                          <div class="logo_percentage">
                            <img src="../../../../assets/images/cloud/100.png" width="100%" height="100%"
                              alt="90perctenage">
                          </div>
                        </div>
                        <div class="sub_hierarchy_map_list">
                          <div class="sub_hierarchy_map_name">Score Team</div>
                          <div class="logo_percentage">
                            <img src="../../../../assets/images/cloud/50.png" width="100%" height="100%"
                              alt="90perctenage">
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="org_map_list ">
                      <div class="Hierarchy_map capabilities_container">
                        <div class="name_class"><span>
                            Capabilities
                          </span></div>
                      </div>
                      <div class="sub_hierarchy_map_container">
                        <div class="sub_hierarchy_map_list">
                          <div class="sub_hierarchy_map_name">Skill Diversity</div>
                          <div class="logo_percentage">
                            <img src="../../../../assets/images/cloud/50.png" width="100%" height="100%"
                              alt="50perctenage">
                          </div>
                        </div>
                        <div class="sub_hierarchy_map_list">
                          <div class="sub_hierarchy_map_name">Certifications</div>
                          <div class="logo_percentage">
                            <img src="../../../../assets/images/cloud/25.png" width="100%" height="100%"
                              alt="25perctenage">
                          </div>
                        </div>
                        <div class="sub_hierarchy_map_list">
                          <div class="sub_hierarchy_map_name">Tools & FrameWorks</div>
                          <div class="logo_percentage">
                            <img src="../../../../assets/images/cloud/50.png" width="100%" height="100%"
                              alt="50perctenage">
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="org_map_list ">
                      <div class="Hierarchy_map marketing_container">
                        <div class="name_class"><span>
                            Marketing
                          </span></div>
                      </div>
                      <div class="sub_hierarchy_map_container">
                        <div class="sub_hierarchy_map_list">
                          <div class="sub_hierarchy_map_name">Partnerships</div>
                          <div class="logo_percentage">
                            <img src="../../../../assets/images/cloud/75.png" width="100%" height="100%"
                              alt="75perctenage">
                          </div>
                        </div>
                        <div class="sub_hierarchy_map_list">
                          <div class="sub_hierarchy_map_name">Demoable Content</div>
                          <div class="logo_percentage">
                            <img src="../../../../assets/images/cloud/50.png" width="100%" height="100%"
                              alt="50perctenage">
                          </div>
                        </div>
                        <div class="sub_hierarchy_map_list">
                          <div class="sub_hierarchy_map_name">Case Studies</div>
                          <div class="logo_percentage">
                            <img src="../../../../assets/images/cloud/75.png" width="100%" height="100%"
                              alt="75perctenage">
                          </div>
                        </div>
                        <div class="sub_hierarchy_map_list">
                          <div class="sub_hierarchy_map_name">Blogs/White papers</div>
                          <div class="logo_percentage">
                            <img src="../../../../assets/images/cloud/25.png" width="100%" height="100%"
                              alt="25perctenage">
                          </div>
                        </div>
                        <div class="sub_hierarchy_map_list">
                          <div class="sub_hierarchy_map_name">Keynote Sessions</div>
                          <div class="logo_percentage">
                            <img src="../../../../assets/images/cloud/25.png" width="100%" height="100%"
                              alt="25perctenage">
                          </div>
                        </div>
                        <div class="sub_hierarchy_map_list">
                          <div class="sub_hierarchy_map_name">Customer References</div>
                          <div class="logo_percentage">
                            <img src="../../../../assets/images/cloud/75.png" width="100%" height="100%"
                              alt="75perctenage">
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="popup" *ngIf="showPopup">
                <div class="popup-content">
                  <div class="filter">
                    <div class="title">
                      <span>Reconfigure KPIs</span>
                    </div>
                    <div class="all-checkboxes">
                      <div *ngFor="let item of checkboxesKPIs" class="checkboxes">
                        <input type="checkbox" (change)="changeOfKPIs($event.target.checked,item.label)"
                          [checked]="checkedKPIs(item.label)" />
                        <label>{{ item.label }}</label>
                      </div>
                    </div>
                    <button class="filterbutton" (click)="printSelectedCheckboxesKPIs()">Apply Filters</button>
                    <button class="close-button" (click)="closePopup()">Close</button>
                  </div>
                  <br>
                  <div class="filter">
                    <div class="title">
                      <span>Reconfigure Widgets</span>
                    </div>
                    <div class="all-checkboxes">
                      <div *ngFor="let item of checkboxesWidgets" class="checkboxes">
                        <input type="checkbox" (change)="changeOfWidgets($event.target.checked,item.label)"
                          [checked]="checkedWidgets(item.label)" />
                        <label [for]="item.id">{{ item.label }}</label>
                      </div>
                    </div>
                    <button class="filterbutton" (click)="printSelectedCheckboxesWidgets()">Apply Filters</button>
                    <button class="close-button" (click)="closePopup()">Close</button>
                    <br>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>

      <div class="toggleshow" *ngIf="hideIt">
        <div class="orgdis">
          <span class="material-symbols-outlined orgmanager">
            lan
          </span>
          <span class="orgmanagerdis">OrgChart Manager's Hierarchy</span>
          <span class="material-symbols-outlined orgArrow" (click)="orgArrowBack()">
            arrow_circle_left
          </span>
        </div>
        <app-org-chart></app-org-chart>
      </div>